import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { showAccessDeniedAlert } from "../../../utils/accessDenied"
import RoutesMap from "../../../route_control/RouteControl"
import axios from "axios"
import moment from "moment/moment"

export const eventList = createAsyncThunk('eventList', async ({ pageable: data, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `event_data`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'category_id': data?.category,
                'date': data?.date && moment(data?.date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                'city_id': data?.city,
                'status': 'active'
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + localStorage.getItem('user_token'),
            }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const eventListSlice = createSlice({
    name: 'eventList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(eventList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                localStorage.clear()
                action.meta.arg.navigate(RoutesMap.LOGIN.path)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }

        });
        builder.addCase(eventList.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default eventListSlice.reducer; 